import { useQuery } from '@apollo/client';
import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';

import NotFound from 'Components/NotFound/NotFound';
import RedirectWithStatus from 'common/CustomRoutes/RedirectWithStatus';
import SPPublicProfile from 'pages/SPPublicProfile/SPPublicProfile.async';
import { ProfileRedirectResponse, slugAliasRedirectQuery } from 'utils/graphql/slug';

const SPPublicProfileRedirector: FC = () => {
  const { pathname } = useLocation();
  const { data } = useQuery<ProfileRedirectResponse>(slugAliasRedirectQuery, {
    variables: {
      pathname: pathname,
    },
  });

  if (data) {
    const response = data.slugAliasRedirect;

    if (response.statusCode === 301) {
      return <RedirectWithStatus to={response.pathname} status={response.statusCode} />;
    }
    if (response.statusCode === 200) {
      return <SPPublicProfile />;
    }
    if (response.statusCode === 404) return <NotFound />;
  }
  return null;
};

export default SPPublicProfileRedirector;
